import { Injectable } from '@angular/core';
import {
  CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TokenStorageService } from '@auth/services/token-storage.service';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: NavController, private tokenStorage: TokenStorageService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>((resolve) => {
      this.tokenStorage
        .isExpired()
        .then((expired) => {
          if (expired) {
            this.router.navigateRoot('/auth/login', { queryParams: { redirectUri: state.url } });
            resolve(false);
          }

          resolve(true);
        })
        .catch(() => {
          this.router.navigateRoot('/auth/login', { queryParams: { redirectUri: state.url } });
          resolve(false);
        });
    });
  }
}
